export default __webpack_public_path__ + "static/media/d9.95ebdb63.jpeg";